import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function ForbiddenPage() {
  return (
    <>
      <SEOHead
        title="403 - Adgang nægtet | Gribskovsmeden ApS"
        description="Du har ikke tilladelse til at tilgå denne side. Gå tilbage til forsiden."
      />

      <div className="min-h-[65vh] flex items-center justify-center py-20 bg-stone-50 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-10 rounded-2xl shadow-sm border border-stone-200">
          <div className="w-16 h-16 bg-red-50 text-red-600 rounded-2xl flex items-center justify-center mx-auto text-2xl font-bold">
            <i className="fa-solid fa-lock" aria-hidden="true"></i>
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-stone-900 tracking-tight">
              403 - Adgang nægtet
            </h1>
            <p className="text-stone-600 text-sm leading-relaxed">
              Du har desværre ikke tilladelse til at se det ønskede indhold.
            </p>
          </div>

          <div className="pt-4 flex flex-col gap-2.5">
            <Link
              to="/"
              className="w-full py-3 bg-stone-900 hover:bg-stone-800 text-white font-bold text-sm rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-house text-xs" aria-hidden="true"></i>
              <span>Gå til forsiden</span>
            </Link>
            <Link
              to="/kontakt"
              className="w-full py-3 bg-stone-100 hover:bg-stone-200 text-stone-800 font-semibold text-sm rounded-lg transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
